<template>
  <HeaderTop @update-search="searchKeyword = $event" />
  <div class="content">
    <div class="welcome between">
      <h1 class="titleWelcome">
        {{ t('dashboard.welcome') }} {{ userStore.user.firstName }} !
      </h1>
    </div>
    <div>
      <cs-modal
        :is-opened="modalDisplayed"
        :title="t('modal.subTitle')"
        :description="`${userLinks.length} ${t('dashboard.lienUtilTitle')}`"
        @close="closeModal"
        class="modalLink"
        data-qa="modal-personnaliser"
      >
        <template #rightHeader>
          <div class="header">
            <cs-button
              class="btn-new-link"
              icon="ajouter"
              type="secondary"
              :text="t('modal.nouveauLien')"
              @click="createNewEntry"
              data-qa="add-link"
              :disabled="isAddButtonDisabled"
            />
          </div>
        </template>
        <template #default>
          <ul class="link-list" data-qa="Liste-liens">
            <li
              v-for="link in userLinks"
              :key="link.id"
              :class="['link-item', { 'edit-link': editableLink === link.id }]"
            >
              <div class="link-text">
                <strong>{{ link.name }}</strong>
                <div v-if="editableLink !== link.id">{{ link.url }}</div>
              </div>
              <div class="actions">
                <cs-button
                  :aria-label="t('links.editLink', { name: link.name })"
                  :title="t('links.editLink', { name: link.name })"
                  icon="modifier"
                  type="tertiary"
                  size="tiny"
                  data-cy-id="button-success-7"
                  @click="editLink(link)"
                />
                <cs-button
                  :aria-label="t('links.deleteLink', { name: link.name })"
                  :title="t('links.deleteLink', { name: link.name })"
                  type="secondary"
                  icon="supprimer"
                  size="small"
                  status="destructive"
                  @click="linkToDelete = link.id"
                />
                <cs-confirmation-popup
                  class="confirmation-popup-delete"
                  v-if="linkToDelete === link.id"
                  data-qa="confirmation-popup-delete"
                  :is-opened="true"
                  @confirmation="(result: boolean) => {
    if (result) confirmDelete(link.id)
    linkToDelete = null
  }"
                  @cancel="linkToDelete = null"
                >
                  <template #importantMessage>
                    <span
                      class="Confirm-text"
                      v-html="t('modal.confirmDeleteLien')"
                    />
                  </template>
                </cs-confirmation-popup>
              </div>
              <div v-if="editableLink == link.id" class="newEntry">
                <label for="nameLink">{{ t('modal.labelName') }} </label>
                <CsInputText
                  id="nameLink"
                  category="primary"
                  :disabled="false"
                  minLength="0"
                  maxLength="50"
                  size="regular"
                  :placeholder="'Exemple : Cegedim Business Services'"
                  :modelValue="editableValue.name"
                  @update:modelValue="updateValue($event, 'name')"
                />
                <label for="link">{{ t('modal.labelLien') }}</label>
                <CsInputText
                  id="link"
                  category="primary"
                  :disabled="false"
                  :minLength="0"
                  size="regular"
                  :placeholder="'Exemple : https://www.cegedim-business-services.com/'"
                  :modelValue="editableValue.url"
                  @update:modelValue="updateValue($event, 'url')"
                />
                <label for="file">{{ t('modal.labelImage') }}</label>
                <cs-file-card
                  v-if="!uploadEdit"
                  :file-name="editableValue.s3Key"
                  format="line"
                >
                  <template #default>
                    <cs-button
                      icon="effacer"
                      type="tertiary"
                      status="default"
                      @click="removeFile"
                    />
                  </template>
                </cs-file-card>
                <cs-upload
                  v-if="uploadEdit"
                  show-file-name
                  :accept="acceptedTypes"
                  :allowedTypes="acceptedTypes"
                  v-model="editableValue.file"
                  @change="changeFile($event, true)"
                />
                <div class="footer">
                  <cs-button
                    type="secondary"
                    :text="t('panel.Cancel')"
                    @click="cancel(true)"
                    data-qa="cancel-button"
                  />
                  <cs-button
                    icon="enregistrer"
                    type="primary"
                    :text="t('modal.saveUpdate')"
                    @click="update"
                    data-qa="save-button"
                    :disabled="isEditDisabled"
                  />
                </div>
              </div>
            </li>
          </ul>
          <div v-if="isNew" ref="targetSection" class="newEntry">
            <h3>{{ t('modal.nouveauLien') }}</h3>
            <label for="nameLink">{{ t('modal.labelName') }}</label>
            <CsInputText
              id="nameLink"
              category="primary"
              :disabled="false"
              minLength="0"
              maxLength="50"
              size="regular"
              :placeholder="'Exemple : Cegedim Business Services'"
              v-modelValue="newEntry.name"
              @update:modelValue="createValue($event, 'name')"
            />
            <label for="link">{{ t('modal.labelLien') }}</label>
            <CsInputText
              id="link"
              category="primary"
              :disabled="false"
              :minLength="0"
              size="regular"
              :placeholder="'Exemple : https://www.cegedim-business-services.com/'"
              v-modelValue="newEntry.url"
              @update:modelValue="createValue($event, 'url')"
            />
            <label for="file">{{ t('modal.labelImage') }}</label>
            <cs-file-drop-zone
              id="file"
              :acceptedTypes="acceptedTypes"
              @change="changeFile"
            />
            <div class="footer">
              <cs-button
                type="secondary"
                :text="t('panel.Cancel')"
                @click="cancel(false)"
                data-qa="cancel-button"
              />
              <cs-button
                icon="enregistrer"
                type="primary"
                :text="t('panel.Save')"
                @click="save"
                data-qa="save-button"
                :disabled="isCreateDisabled"
              />
            </div>
          </div>
        </template>
      </cs-modal>
    </div>
    <!-- <div data-qa="recently-opened-wrapper">
      <RecentlyOpened
        :apps="userStore.userApps"
        :refresh="refreshKey"
        data-qa="recently-opened-component"
        @update-refresh="forceRefreshRecentlyOpened"
      />
    </div>-->
      <ProductCard
        :apps="userStore.userApps"
        :search-keyword="searchKeyword"
        @opened="forceRefreshRecentlyOpened"
        @clicked="handleProductCardClick"
        data-qa="my-apps-product-card"
        :favorite-list="userStore.userInDb.favorite || []"
        class="ProductCard"
        @mouseenter="handleMouseEnter"
        @mouseleave="handleMouseLeave"
        :class="{ ProductCard: true, 'show-scroll': showScroll }"
      />
    <div v-if="hasNews" class="content-body">
      <el-row :gutter="20">
        <el-col :span="16" class="liens-util">
          <LiensUtilWidget
            @onClickPersonnalisation="showPersonnalisationModal"
            @close="modalDisplayed = false"
          ></LiensUtilWidget>
          <el-row :gutter="20" class="bottom-nav">
            <el-col :span="12" class="astuce-jour">
              <AstuceJourWidget></AstuceJourWidget>
            </el-col>
            <el-col :span="12" class="video-nav">
              <VideoWidget></VideoWidget>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="8" class="demo-radius2 news-widget">
          <NewsWidget />
        </el-col>
      </el-row>
    </div>
    <!--  Affichage sans le widget d’actualités  -->
    <div v-else class="content-body">
      <el-row :gutter="20" class="content-without-news">
        <el-col :span="12" class="liens-util1">
          <LiensUtilWidget
            @onClickPersonnalisation="showPersonnalisationModal"
            @close="modalDisplayed = false"
          ></LiensUtilWidget>
        </el-col>
        <el-col :span="12" class="demo-radius2 news-widget">
          <el-col class="astuce-jour">
            <AstuceJourWidget></AstuceJourWidget>
          </el-col>
          <el-col class="video-nav1">
            <VideoWidget></VideoWidget>
          </el-col>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, computed, onMounted, nextTick, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { UseStoreUser } from '@/store/userStore';
import { UseStoreNews } from '@/store/newsStore';
import { UseStoreCategory } from '@/store/categoryStore';
import ProductCard from '@/components/ProductCard.vue';
import HeaderTop from '@/components/HeaderTop.vue';
import NewsWidget from '@/components/NewsWidget.vue';
import { UseClientStore } from '@/store/clientStore';
import habService from '@/services/habService';
import VideoWidget from '@/components/VideoWidget.vue';
import LiensUtilWidget from '@/components/LiensUtilWidget.vue';
import AstuceJourWidget from '@/components/AstuceJourWidget.vue';
import {
  handleMouseEnter,
  handleMouseLeave,
  showScroll,
} from '@/utils/ui-utils';
import { matomoTracker } from '@/utils/matomo';

const { t, locale } = useI18n();
const searchKeyword = ref('');
const targetSection = ref<HTMLElement | null>(null);
const linkToDelete = ref<string | null>(null);
const newsStore = UseStoreNews();
const hasNews = computed(() => newsStore.news.length > 0);

const editableLink = ref<string | null>(null);
const isAddButtonDisabled = ref<boolean | null>(false);
const userStore = UseStoreUser();
const userLinks = computed(() =>
  userStore.userLinks.filter(link => !link.isAddedByAdmin)
);
const editableValue = ref<any>();
const uploadEdit = ref<boolean>(false);
const removeFile = () => {
  editableValue.value.file = null;
  editableValue.value.imageBase64 = '';
  editableValue.value.s3Key = '';
  uploadEdit.value = true;
};

watch(
  () => locale.value,
  newLang => {
    document.documentElement.setAttribute('lang', newLang);
  }
);

function confirmDelete(linkId: string): void {
  userStore.deleteUserLink(linkId);
}

function isValidUrl(url: string): boolean {
  try {
    const parsed = new URL(url);
    return ['http:', 'https:'].includes(parsed.protocol);
  } catch {
    return false;
  }
}

function isValidEntry(
  entry: { name?: string; url?: string; file?: File },
  requireFile: boolean
): any {
  return (
    entry.name?.trim() &&
    entry.url?.trim() &&
    isValidUrl(entry.url) &&
    (!requireFile || (entry.file && entry.file.size > 0))
  );
}

function shouldDisable(isUpdate: boolean): boolean {
  return !isValidEntry(
    isUpdate ? editableValue.value : newEntry.value,
    !isUpdate
  );
}
const isEditDisabled = computed(() => {
  return !(
    editableValue.value.name?.trim() &&
    editableValue.value.url?.trim() &&
    isValidUrl(editableValue.value.url) &&
    editableValue.value.file &&
    editableValue.value.file.size > 0
  );
});
const isCreateDisabled = computed(() => shouldDisable(false));

function base64ToFile(base64: string, filename: string): File {
  // Fix wrong MIME type if needed
  if (base64.startsWith('data:application/octet-stream')) {
    if (base64.includes('svg')) {
      base64 = base64.replace('application/octet-stream', 'image/svg+xml');
    } else {
      base64 = base64.replace('application/octet-stream', 'image/png'); // fallback
    }
  }

  const arr = base64.split(',');
  const mimeMatch = arr[0].match(/:(.*?);/);

  if (!mimeMatch) {
    throw new Error('Invalid base64 format');
  }

  const mime = mimeMatch[1];
  const byteString = atob(arr[1]);
  const u8arr = new Uint8Array(byteString.length);

  for (let i = 0; i < byteString.length; i++) {
    u8arr[i] = byteString.charCodeAt(i);
  }

  return new File([u8arr], filename, { type: mime });
}

function editLink(link: any) {
  isAddButtonDisabled.value = true;
  isNew.value = false;
  editableLink.value = link.id;
  editableValue.value = { ...link };
  setTimeout(() => {
    changeFile(
      base64ToFile(editableValue.value.imageBase64, editableValue.value.s3Key),
      true
    );
  }, 1000);
}
const clientStore = UseClientStore();

const categoryStore = UseStoreCategory();

// await categoryStore.loadCategories();

await newsStore.loadNews(1);

await clientStore.getClientInfoFromRcu();

await clientStore.getTeamsRhPortalLink();

habService.loadUserRolesFromToken();
const router = useRouter();
const hasRolesLoaded =
  Object.keys(userStore.userRoles).length > 0;
if (hasRolesLoaded && !userStore.hasAnyHubRole) {
  router.replace({ name: 'access-denied' });
}
if (userStore.hasAnyHubRole) {
  await userStore.getUserApps();
}

const acceptedTypes = ref('.jpeg, .png, .gif,.svg , .webp');

const isNew = ref(false);
const newEntry = ref<{
  name: string;
  url: string;
  file: File | null;
}>({
  name: '',
  url: '',
  file: null,
});

function changeFile(file: any, isupdate: boolean = false) {
  if (
    file &&
    (file.type.startsWith('image/') || file.type == 'application/octet-stream')
  ) {
    if (isupdate) editableValue.value.file = file;
    else newEntry.value.file = file;
  }
}
function createNewEntry() {
  isAddButtonDisabled.value = true;
  editableLink.value = null;
  isNew.value = true;
  nextTick(() => {
    targetSection.value?.scrollIntoView({ behavior: 'smooth' });
  });
}
const modalDisplayed = ref(false);
async function save() {
  isAddButtonDisabled.value = false;
  const userId = userStore.user.id;
  if (!userId) return;
  await userStore.createUserLink({
    name: newEntry.value.name,
    url: newEntry.value.url,
    userId,
    ...(newEntry.value.file ? { file: newEntry.value.file } : {}),
  });
  newEntry.value = {
    name: '',
    url: '',
    file: null,
  };

  isNew.value = false;
}
async function update() {
  isAddButtonDisabled.value = false;
  await userStore.updateUserLink({
    ...editableValue.value,
    userId: userStore.user.id,
  });
  editableLink.value = null;
  editableValue.value = null;
}
function createValue(event: string, field: string) {
  newEntry.value = {
    ...newEntry.value,
    [field]: event,
  };
}
function updateValue(event: string, field: string) {
  editableValue.value = {
    ...editableValue.value,
    [field]: event,
  };
}
function cancel(isUpdate: boolean = false) {
  isAddButtonDisabled.value = false;
  if (isUpdate) {
    editableLink.value = null;
    editableValue.value = null;
    uploadEdit.value = false;
  } else {
    newEntry.value = {
      name: '',
      url: '',
      file: null,
    };
    isNew.value = false;
  }
}
function showPersonnalisationModal() {
  modalDisplayed.value = true;
}
function closeModal() {
  isAddButtonDisabled.value = false;
  editableLink.value = null;
  editableValue.value = null;
  uploadEdit.value = false;
  modalDisplayed.value = false;
  isNew.value = false;
}
onMounted(async () => {
  const { locale } = useI18n();
  if (!userStore.userInDb || Object.keys(userStore.userInDb).length === 0) {
    try {
      await userStore.createUser({
        id: userStore.user.id!,
        username: userStore.user.username,
        favorite: [],
        preferences: { language: 'fr' },
      });
      console.log('User created successfully!');
    } catch (err) {
      console.log(t('errors.user'), err);
    }
  }
  const lang = userStore.userInDb?.preferences?.language || 'fr';
  locale.value = lang;
});

const refreshKey = ref(0);

function forceRefreshRecentlyOpened() {
  refreshKey.value++;
}

// Track ProductCard clicks
function handleProductCardClick(appId: string) {
  matomoTracker.trackEvent('ProductCard', 'click', appId);
}
</script>

<style scoped lang="scss">
.content-body {
  margin-bottom: 1rem !important;
}
.Confirm-text {
  margin-left: 0 !important;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
:deep(.cs-input-text .cs-input-text-clear.has-max-length.regular) {
  left: 85% !important;
}
.subtitle {
  font-size: 1rem;
  font-weight: 600;
}
.edit-link {
  padding: 0.5rem !important;
  background: #f2f2f2;
  border-radius: 8px;
}
.btn-new-link {
  background-color: #f0f8ff;
  border: 1px solid #3399ff;
  color: #3399ff;
  padding: 0.3rem 0.75rem;
  border-radius: 5px;
  font-size: 0.875rem;
  cursor: pointer;
}

.link-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.link-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 0;
  border-bottom: 1px solid #f0f0f0;
  flex-wrap: wrap;
}

.link-text {
  max-width: 70%;
}

.actions {
  display: flex;
  gap: 0.5rem;
}

.btn-icon {
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 1rem;
}

.btn-icon.danger {
  color: red;
}

.btn-close {
  padding: 0.5rem 1rem;
  border-radius: 5px;
  background-color: #f1f5f9;
  border: none;
  cursor: pointer;
}
:deep(
    .cs-file-card
      .cs-file-card-container
      .cs-file-card-info
      .cs-file-card-left
      .cs-file-card-text
  ) {
  gap: 18.125rem;
}
:deep(.cs-widget .cs-widget-content) {
  display: block !important;
  overflow: hidden !important;
  margin: 0 1rem 0 1rem !important;
}
:deep(.cs-widget .cs-widget-content:hover) {
  overflow: auto !important;
}
html,
body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}
.titleWelcome {
  font-size: 2rem !important;
  font-weight: 700 !important;
  display: inline !important;
}
.bottom-nav {
  margin-top: 1rem !important;
  margin-left: 0px !important;
  margin-right: 0px !important;
}
.liens-util {
  height: 16rem !important;
}
liens-util1 {
  height: 35rem !important;
}
.content-without-news {
  height: 35rem;
  margin-bottom: 1rem;
}
.news-widget {
  height: 34rem !important;
}
.astuce-jour {
  height: 17rem !important;
  padding-right: 0px !important;
  padding-left: 0px !important;
}
.video-nav {
  height: 17rem !important;
  padding-right: 0px !important;
  padding-left: 10px !important;
}
.video-nav1 {
  height: 17rem !important;
  padding-right: 0px !important;
  padding-left: 0px !important;
  margin-top: 1rem !important;
}

@media screen and (min-width: 1700px) and (max-width: 1900px) {
  .astuce-jour {
    height: 17.5rem !important;
  }
  .news-widget {
    height: 37rem !important;
  }
  .liens-util {
    height: 18.5rem !important;
  }
  .liens-util1 {
    height: 36rem !important;
  }
}

@media screen and (min-width: 1910px) and (max-width: 2100px) {
  .astuce-jour {
    height: 19.5rem !important;
  }
  .news-widget {
    height: 40rem !important;
  }
  .liens-util {
    height: 19.5rem !important;
  }
  .liens-util1 {
    height: 40rem !important;
  }
}

@media screen and (min-width: 2101px) {
  .astuce-jour {
    height: 23rem !important;
    margin-bottom: 1rem !important;
  }
  .news-widget {
    height: 40rem !important;
  }
  .liens-util {
    height: 22.5rem !important;
  }
  .liens-util1 {
    height: 47rem !important;
  }
}

.productCard {
  overflow-x: hidden;
  transition: overflow 0.3s ease;
}
.productCard.show-scroll {
  overflow-x: auto;
}

@media screen and (min-width: $tab-port-max) {
  .demo-radius2 {
    flex: 2;
  }
  .activity,
  .content-body {
    display: flex;
    margin-bottom: 1rem;
  }
  .welcome {
    flex: 1;
    margin-top: 2rem !important;
    margin-bottom: 1rem !important;
  }

  .vide {
    flex: 1;
  }
  .search {
    float: 1;
  }
  .banner-header {
    display: flex;
  }

  .between {
    align-self: center;
  }
  .chercher {
    width: $margin-25;
  }
  .act {
    margin-right: $margin-1-5;
  }
}

@media screen and (max-width: $tab-port-max) {
  .demo-radius2 {
    max-width: 100% !important;
  }
  .classes {
    text-align: center;
  }

  .buttons {
    font-size: $font-1-1;
    padding: $padding-0-3;
    height: $srh4u_buttons;
  }
}

.welcome,
.vide,
.search {
  margin: $margin-0-625 auto;
}

.top-header {
  background-color: #f1f8ff;
  padding: 4px 4px 4px 88px;
  height: 48px;
  width: 100%;
  overflow-x: hidden;
  box-shadow: 0px 4px 24px rgba(1, 103, 255, 0.06);
}

.demo-radius {
  justify-content: center;
  flex-wrap: revert !important;
}

.cegedim_logo {
  text-align: center;
}
h2 {
  font-size: $margin-2;
  font-weight: bold;
  display: inline;
}

.search {
  flex: 1;
  text-align: right;
}

.vide {
  flex: 1;
  text-align: center;
}

.content {
  margin-left: $menuBarWidth;
  margin-right: 1rem;
}

.radius {
  margin: auto $margin-0-938;
  cursor: pointer;
  box-shadow: shadow(1px, 1px, $apps-shadow-color) inset,
    shadow(1px, 1px, $apps-shadow-color);
  background-color: $white-hub;
}

.demo-radius {
  flex-wrap: revert !important;
}
.demo-radius .title {
  color: var(--el-text-color-regular);
  font-size: $margin-1;
  margin: $margin-0-625 0;
}
.demo-radius .value {
  color: var(--el-text-color-primary);
  font-size: $margin-1;
  margin: $margin-0-625 0;
}
.demo-radius .radius {
  height: $box-height;
  width: $box-width;
  border: 1px solid var(--el-border-color);
  border-radius: $border-radius;
  margin-top: $margin-1-25;
  white-space: normal;
}
.programs {
  height: $programs-height;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  text-align: center;
}

// Hiding the scroll bar
.programs {
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
}
.programs::-webkit-scrollbar {
  display: none; /* Safari and Chrome */
}

.icon {
  float: right;
  position: relative;
  top: $icon-top;
  margin: auto $margin-0-313;
}

.radius {
  margin: auto $margin-0-938;
}

.demo-radius .title {
  color: var(--el-text-color-regular);
  font-size: $margin-1;
  margin: $margin-0-625 0;
}
.demo-radius .value {
  color: var(--el-text-color-primary);
  font-size: $margin-1;
  margin: $margin-0-625 0;
}
.radius2 {
  min-height: $footer-height;
  width: 100%;
  border: 1px solid var(--el-border-color);
  border-radius: $margin-0-625;
  background-color: $white-hub;
}
.nouvaute {
  padding: $padding-1-3;
}
.titleMesApplication {
  font-size: 1rem;
  line-height: 1.5rem;
  margin-left: 0.25rem;
  color: #1a1a1a;
  font-family: Nunito, sans-serif;
}
.notifications {
  padding: $padding-1-3;
}
:deep() .not > .radius2,
.act > .radius2 {
  height: 100%;
}
.classes {
  margin-top: $margin-0-625;
}

span {
  margin-left: $font-0-7;
  font-size: $font-1;
}

.ShowPlus {
  text-align: center;
  font-size: $font-1;
}

.btn_show {
  font-size: $font-1;
}

.items {
  margin: $margin-0-313 auto;
}

.counter {
  font-size: $font-1;
  padding: $padding-0-1;
  color: red;
}
p {
  font-weight: bold;
}

.classes {
  margin-bottom: $margin-0-625;
}

.right_cards:first-child {
  min-height: $srh4you-heigth;
  line-break: anywhere;
  margin-bottom: $margin-1;
  cursor: pointer;
  box-shadow: shadow(1px, 1px, $gray-card);
  border-radius: 10px; //border radius in px
  height: calc(100% - $margin-1);
}

.foot {
  float: right;
}

.smll {
  font-size: 50%;
}

abbr {
  font-weight: 600;
  float: right;
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d($transform, 0, 0);
    box-shadow: 1px 1px $box-moving inset, 1px 1px $box-moving;
  }
  40%,
  60% {
    transform: translate3d(0, 0, 0);
  }
}

.apply-shake {
  animation: shake 1.4s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
}

@keyframes shake2 {
  10%,
  90% {
    transform: translate3d(-$transform, 0, 0);
    box-shadow: 1px 1px $box-moving inset, 1px 1px $box-moving;
  }
  40%,
  60% {
    transform: translate3d(0, 0, 0);
  }
}

.apply-shake2 {
  animation: shake2 1.4s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
}

.redirect {
  text-decoration: none;
}
.lire {
  color: $white-hub;
  background: $blue-hub !important;
  padding: $padding-0-125 $padding-0-625;
  border-radius: 5px; //border radius should be in px
  cursor: grabbing;
}

.foot-card {
  padding: 0 $padding-1;
  float: right;
  margin-bottom: $margin-0-313;
}

.imgs {
  height: $little-boxes;
  width: 100%;
  -o-object-fit: cover;
  object-fit: cover;
}

.big_img {
  height: $box-height;
  width: 100%;
  height: $srh4u-images-height;
  -o-object-fit: cover;
  object-fit: cover;
}
.pad {
  padding: $padding-1;
}

.pad0top {
  padding-top: 0;
  font-size: $font-0-8;
}

.card_big {
  height: calc(100% - $margin-1);
  padding: 0;
  border-radius: 10px;
}

.big_title {
  font-size: $font-1-3;
}
.titles {
  font-size: $font-1;
}
.el-row {
  width: 100%;
  margin: 0;
}
.newEntry {
  display: flex;
  flex-direction: column;
  width: 100%;
}

:deep(.cs-input-text) {
  margin: 0;
}
:deep(.cs-input-text .cs-input-text-input.regular) {
  width: 35.813rem;
}
:deep(.cs-upload) {
  background: white;
}
:deep(.modalLink .cs-popup-container) {
  width: 35.813rem !important;
}

:deep(.cs-file-card.cs-file-card-line) {
  width: 100% !important;
}

:deep(.cs-file-drop-zone) {
  width: auto;
  padding: 2px;
}
.footer {
  display: flex;
  justify-content: space-between;
  padding: 10px 0px;
}
:deep(
    .cs-modal.cs-popup-container-container .cs-popup-container .cs-modal-header
  ) {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
:deep(.cs-modal.cs-popup-container-container .cs-popup-container) {
  max-width: 70% !important;
}
:deep(
    .cs-modal.cs-popup-container-container
      .cs-popup-container
      .cs-modal-header
      .cs-modal-description
  ) {
  order: 2;
  width: 100%;
}
:deep(
    .cs-modal.cs-popup-container-container
      .cs-popup-container
      .cs-modal-header
      .cs-modal-description
  ) {
  color: #5a6169 !important;
}
</style>
